
import { Modal } from 'bootstrap';
import { defineComponent, ref, inject, watchEffect, computed } from 'vue';
import InnerLoader from '../../../../../components/InnerLoader.vue';
import Table from '../../../../../components/Table/Table.vue';
import { useWms } from '@/modules/wms/helpers';

export default defineComponent({
    name: 'product to warehouses',
    components: {
        InnerLoader,
        Table
    },
    props: {
        warehouses: Array
    },

    setup(props) {
        const emitter: any = inject('emitter');
        const loading = ref(false);
        const modal: any = ref();
        const warehouses_data = ref([]) as Record<any, any>;
        const { wmsManagesProducts } = useWms();

        // WMS: warehouse name; shop admin managed: warehouse code (as before WMS)
        const columns = computed(() => [
            {
                label: 'message.NO',
                key: 'no'
            },
            wmsManagesProducts.value
                ? {
                      label: 'message.WAREHOUSE',
                      key: 'warehouse_name'
                  }
                : {
                      label: 'message.WAREHOUSE_CODE',
                      key: 'warehouse_code'
                  },
            {
                label: 'message.STOCK',
                key: 'stock'
            }
        ]);
        // Emitter for open modal
        emitter.on('productToWarehouseAction', () => {
            modal.value = new Modal(document.getElementById('product_to_warehouses'));
            modal.value.show();
        });

        watchEffect(() => {
            // warehouses_data.value = props?.warehouses;
            if (props?.warehouses != null) {
                if (wmsManagesProducts.value) {
                    // every warehouse Smart reports, also with 0 stock; name (code when the warehouse is unknown)
                    warehouses_data.value = props?.warehouses.map((item: any) => ({ ...item, warehouse_name: item.warehouse?.name ?? item.warehouse_code }));
                } else {
                    warehouses_data.value = props?.warehouses.filter(function(item: any) {
                        return item.stock != 0;
                    });
                }
            }
        });

        return {
            wmsManagesProducts,
            loading,
            warehouses_data,
            columns
        };
    }
});
